<template>
    <div class="row">
        <EventCard v-for="(rdv, index) in rdvsFinished" :key="index" :rdv="rdv" detail="past" @edit-rdv="handleEdit"></EventCard>
    </div>
</template>

<script>
    import EventCard from "./EventCard.vue";
    export default {
        name : "Historique",
        props : ['rdvsFinished'],
        data () {
            return {
            }
        },
        components : { EventCard },
        methods: {
            
        }
    }
</script>